import {Box, Title} from '@mantine/core';
import React from 'react';

export enum HelpGuideTab {
  BASICS = 'BASICS',
  COMPONENTS = 'COMPONENTS',
  EXAMPLES = 'EXAMPLES',
}

export function VeritasHelpModalSection({children}: {children: React.ReactNode}): JSX.Element {
  return (
    <Box mb="lg" fz="md">
      {children}
    </Box>
  );
}

export function VeritasHelpModalSectionTitle({children}: {children: React.ReactNode}): JSX.Element {
  return (
    <Title order={5} mb="md">
      {children}
    </Title>
  );
}
